const SettingsItemsMixin = {
};

export default SettingsItemsMixin;
